import { createActions } from 'redux-actions';

export const { showAlert, hideAlert } = createActions(
  'SHOW_ALERT',
  'HIDE_ALERT'
);
